import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-350"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.466 4.215a.31.31 0 0 0-.08.01 3.066 3.066 0 0 1-.806.109 3.201 3.201 0 0 1-1.06-.185A3.183 3.183 0 0 1 11.492.364.289.289 0 0 0 11.22 0a.279.279 0 0 0-.104.02 3.546 3.546 0 0 0-2.21 3.096 4.928 4.928 0 0 1 .99.293 2.56 2.56 0 0 1 .54-1.671 4.418 4.418 0 0 0 .165.707 4.166 4.166 0 0 0 2.59 2.649 4.328 4.328 0 0 0 .846.203 2.606 2.606 0 0 1-.239.163 3.572 3.572 0 0 1 .823.643 3.553 3.553 0 0 0 1.12-1.504.286.286 0 0 0-.275-.384zm-3.438 1.357a2.937 2.937 0 0 0-.37.037 4.364 4.364 0 0 0-7.316 0 2.938 2.938 0 0 0-.37-.037 2.972 2.972 0 1 0 1.16 5.708 4.302 4.302 0 0 0 5.735 0 2.972 2.972 0 1 0 1.16-5.708zm0 4.944a1.958 1.958 0 0 1-.77-.156 1 1 0 0 0-1.05.168 3.302 3.302 0 0 1-4.417 0 1 1 0 0 0-1.05-.168 1.972 1.972 0 1 1-.769-3.788 1.078 1.078 0 0 1 .15.016l.095.013a1 1 0 0 0 .962-.444 3.364 3.364 0 0 1 5.642 0 1 1 0 0 0 .962.444l.095-.013a1.075 1.075 0 0 1 .15-.016 1.972 1.972 0 1 1 0 3.944zM9.53 15a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm-5.083 0a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2z",
  style: {"fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }